<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
    <Spin />
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import Spin from './components/Spin.vue'

export default {
  name: 'App',
  components: {
    HelloWorld,
    Spin
  }
}
</script>

<style>
body {
  overscroll-behavior: contain;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

</style>
